
import {
  elementOpen,
  elementVoid,
  elementClose,
  text,
  skipNode
} from 'incremental-dom';

export default function (className, elId) {
  var el = elementOpen('div', elId, ['class', [className, 'svg-wrapper', elId].join(' '), 'style', 'overflow: hidden;']);
  el.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 225 200.5" preserveAspectRatio="xMidYMin slice"         width="100%" style="height: 1px;overflow: visible;padding-bottom: 89%"></svg>';
  skipNode(); // Don't clear out children
elementClose('div');
return el;
};